import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SPACES } from "@/lib/spaces";

export const WIDGETS = [
  { key: "weather", label: "Météo" },
  { key: "quick", label: "Accès rapide" },
  { key: "spaces", label: "Mes espaces (dossiers)" },
  { key: "start", label: "Bien démarrer (assistant de démarrage)" },
  { key: "today", label: "Rendez-vous du jour / interventions en cours" },
  { key: "tasks", label: "Tâches" },
  { key: "kpi", label: "Statistiques rapides du mois" },
  { key: "objective", label: "Objectif / chiffre d'affaires" },
  { key: "upcoming", label: "Prochains rendez-vous + alertes (impayés, stock…)" },
  { key: "last7", label: "7 derniers jours + activité" },
  { key: "evolution", label: "Évolution du CA" },
  { key: "top_services", label: "Top prestations" },
  { key: "month_detail", label: "Mois en détail" },
];

export const defaultFolders = () => SPACES.map((s) => ({ id: s.key, label: s.label, desc: s.desc, icon: s.key, c: s.c, items: s.items.map((i) => ({ ...i })) }));
export const shortcutCatalog = () => {
  const seen = new Set(); const out = [];
  SPACES.forEach((s) => s.items.forEach((i) => { const k = `${i.label}|${i.to}`; if (!seen.has(k)) { seen.add(k); out.push(i); } }));
  return out;
};

let cache = null; const subs = new Set();
const emit = () => subs.forEach((f) => f(cache));

export function normalize(p) {
  const known = WIDGETS.map((w) => w.key);
  const ws = (p.widgets || []).filter((w) => known.includes(w.key));
  known.forEach((k) => { if (!ws.some((w) => w.key === k)) ws.push({ key: k, visible: !["today", "tasks"].includes(k) || !p.widgets }); });
  return { folders: p.folders?.length ? p.folders : defaultFolders(), widgets: ws, favorites: p.favorites || [] };
}

export function useDashPrefs() {
  const [prefs, setPrefs] = useState(cache);
  useEffect(() => {
    subs.add(setPrefs);
    if (!cache) api.get("/me/dashboard-prefs").then((r) => { cache = normalize(r.data || {}); emit(); }).catch(() => { cache = normalize({}); emit(); });
    return () => subs.delete(setPrefs);
  }, []);
  const save = async (next) => { cache = normalize(next); emit(); await api.put("/me/dashboard-prefs", next); };
  const reset = async () => { cache = normalize({}); emit(); await api.put("/me/dashboard-prefs", {}); };
  return { prefs, save, reset };
}
